let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ithp8")).then(() => parcelRequire('5NTKt'));